import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from '../../../../../services/helpers.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppConfig } from '../../../../../app.config';
import { RentalsService } from '../../../../../services/rentals.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-rentals-widget-configuration',
  templateUrl: './rentals-widget-configuration.component.html',
  styleUrls: ['./rentals-widget-configuration.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class RentalsWidgetConfigurationComponent implements OnInit {
  public configForm: FormGroup;
  public config: any = {};
  public parentIdentifier: string = '';
  public partnerIdentifier: string = '';
  public loading: boolean = false;
  public saving: boolean = false;
  public iFrameCreated: boolean = false;
  public dangerousURL: string;
  public iFrameLink: SafeResourceUrl | string;
  public iFrameSizer: SafeResourceUrl | string;
  public deliveriesEnabled: boolean = false;
  public showNonDeliveriesWidget : boolean = false;
  public productCategories : any = [];
  public selectedProductCategories : any = [];
  public productGroups : any = [];
  public selectedProductGroups : any = [];

  public fontOptions = [
    {
      value: 'Roboto',
      url: 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;600&display=swap',
    },
    {
      value: 'Lato',
      url: 'https://fonts.googleapis.com/css2?family=Lato:wght@400;500;600&display=swap',
    },
    {
      value: 'Lora',
      url: 'https://fonts.googleapis.com/css2?family=Lora:wght@400;500;600&display=swap',
    },
    {
      value: 'Inter',
      url: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap',
    },
    {
      value: 'Encode Sans',
      url: 'https://fonts.googleapis.com/css2?family=Encode+Sans:wght@400;500;600&display=swap',
    },
    {
      value: 'Manrope',
      url: 'https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600&display=swap',
    },
    {
      value: 'Raleway',
      url: 'https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600&display=swap',
    },
    {
      value: 'Oswald',
      url: 'https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600&display=swap',
    },
    {
      value: 'Montserrat',
      url: 'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600&display=swap',
    },
    {
      value: 'Poppins',
      url: 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap',
    },
    {
      value: 'Work Sans',
      url: 'https://fonts.googleapis.com/css2?family=Work+Sans:wght@400;500;600&display=swap',
    },
    {
      value: 'Archivo',
      url: 'https://fonts.googleapis.com/css2?family=Archivo:wght@400;500;600&display=swap',
    },
    {
      value: 'Merriweather',
      url: 'https://fonts.googleapis.com/css2?family=Merriweather:wght@400;500;600&display=swap',
    },
    {
      value: 'Open Sans',
      url: 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600&display=swap',
    },
    {
      value: 'Source Sans Pro',
      url: 'https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;500;600&display=swap',
    },
    { value: 'Arial', url: 'Built-In' },
    { value: 'Comic Sans MS', url: 'Built-In' },
    { value: 'Lucida', url: 'Built-In' },
    { value: 'Tahoma', url: 'Built-In' },
    { value: 'Times New Roman', url: 'Built-In' },
    { value: 'Trebuchet MS', url: 'Built-In' },
    { value: 'Verdana', url: 'Built-In' },
  ].sort((x, y) => {
    if (x.value > y.value) return 1;
    if (x.value < y.value) return -1;
    return 0;
  });

  constructor(
    private appConfig: AppConfig,
    private fb: FormBuilder,
    private rentalsService: RentalsService,
    public messageService: MessageService,
    private translate: TranslateService,
    private confirmationService: ConfirmationService,
    private helper: HelpersService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.getConfig();
    this.getRentalProducts();

    this.fontOptions.forEach((font) => {
      if (font.url.indexOf('https://') > -1) {
        const head = document.getElementsByTagName('head')[0];
        const style = document.createElement('link');
        style.id = 'css-styling';
        style.rel = 'stylesheet';
        style.href = font.url;
        head.appendChild(style);
      }
    });
  }

  getConfig() {
    this.loading = true;
    this.rentalsService
      .getRentalConfiguration(this.helper.getPartnerId())
      .subscribe(
        (config) => {
          this.config = config;
          this.partnerIdentifier = config.partnerIdentifier;
          this.parentIdentifier = config.parentIdentifier;

          this.deliveriesEnabled = config.enableDeliveries;

          this.createLink();

          this.setupValidation();
          this.loading = false;
        },
        (err) => {
          this.loading = false;
        },
      );
  }

  getRentalProducts(){
    this.rentalsService.getRentalProducts(this.helper.getPartnerId()).subscribe((res: any)=>{
      console.log(res);
      const uniqueCategories = new Map();
        res.filter(x=>{return x.isRental}).forEach(x => uniqueCategories.set(x.categoryID, { value: x.categoryID, label: x.categoryName }));
      this.productCategories = Array.from(uniqueCategories.values())
          .sort((a, b) => a.label.localeCompare(b.label));

      this.productGroups = res.filter(x=>{return x.isRental}).map(x => { return {value : this.getProductIdentifierValue(x.rentalProducts), label : x.brand + " " + x.model }});

    });
  }

  getProductIdentifierValue(rentalProducts : any){
    if (rentalProducts && rentalProducts.length > 0) {
      const identifier = rentalProducts[0].identifier;
      const trimmedIdentifier = identifier.substring(0, identifier.lastIndexOf('_'));
      return trimmedIdentifier
    }
    return null;
  }
  

  setupValidation() {
    this.configForm = this.fb.group({
      // useSettingForAllLinkedStores:new FormControl(
      //   this.config.useSettingForAllLinkedStores || false,
      //   Validators.nullValidator
      // ),
      cardBackground: new FormControl(
        this.config.cardBackground || '#ffffff',
        Validators.nullValidator,
      ),
      defaultBackgroundColor: new FormControl(
        this.config.defaultBackgroundColor || '#eff3f8',
        Validators.nullValidator,
      ),
      primaryColor: new FormControl(
        this.config.primaryColor || '#EE3158',
        Validators.nullValidator,
      ),
      primaryTextColor: new FormControl(
        this.config.primaryTextColor || '#151A2A',
        Validators.nullValidator,
      ),
      secondaryTextColor: new FormControl(
        this.config.secondaryTextColor || '#888888',
        Validators.nullValidator,
      ),
      cardBorderRadius: new FormControl(
        this.config.cardBorderRadius != null
          ? this.config.cardBorderRadius
          : 16,
        Validators.nullValidator,
      ),
      defaultFont: new FormControl(
        this.config.defaultFont ||
          'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600&display=swap',
        Validators.nullValidator,
      ),
      defaultFontName: new FormControl(
        this.config.defaultFontName || 'Montserrat',
        Validators.nullValidator,
      ),
      secondaryFont: new FormControl(
        this.config.secondaryFont ||
          'https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;500;600&display=swap',
        Validators.nullValidator,
      ),
      secondaryFontName: new FormControl(
        this.config.secondaryFontName || 'Source Sans Pro',
        Validators.nullValidator,
      ),
      googleAnalyticsScript: new FormControl(
        this.config.googleAnalyticsScript,
        Validators.nullValidator,
      ),
      captureAddress: new FormControl(
        this.config.captureAddress,
        Validators.nullValidator,
      ),
      facebookPixel: new FormControl(
        this.config.facebookPixel,
        Validators.nullValidator,
      )
    });
  }

  updateColor(event, field) {
    switch (field) {
      case 'primaryColor':
        this.configForm.controls['primaryColor'].setValue(event);
        break;
      case 'primaryTextColor':
        this.configForm.controls['primaryTextColor'].setValue(event);
        break;
      case 'secondaryTextColor':
        this.configForm.controls['secondaryTextColor'].setValue(event);
        break;
      case 'cardBackground':
        this.configForm.controls['cardBackground'].setValue(event);
        break;
      case 'defaultBackgroundColor':
        this.configForm.controls['defaultBackgroundColor'].setValue(event);
        break;
    }
  }

  updateFont(event) {
    this.configForm.controls['defaultFont'].setValue(event.url);
    this.configForm.controls['defaultFontName'].setValue(event.value);
  }

  updateSecondaryFont(event) {
    this.configForm.controls['secondaryFont'].setValue(event.url);
    this.configForm.controls['secondaryFontName'].setValue(event.value);
  }

  getWidgetURL() {
    return this.iFrameLink;
  }

  saveConfig(config) {
    var data = { ...this.config, ...config };

    if (data.partnerID == 0) {
      data.partnerID = this.helper.getPartnerId();
    }

    this.saving = true;
    this.rentalsService.updateRentalConfig(data).subscribe(
      (res) => {
        this.config = res;
        this.createLink();
        this.saving = false;
      },
      (err) => {
        this.saving = false;
      },
    );
  }

  createLink() {
    this.iFrameCreated = false;
    if (this.parentIdentifier && this.config.useSettingForAllLinkedStores) {
      //this.dangerousURL = this.appConfig.getRentalWidgetURL() + "/group-rides/stores/"+this.parentIdentifier;
      this.dangerousURL =
        this.appConfig.getRentalWidgetURL() +
        '/rentals/reserve/' +
        this.partnerIdentifier +
        (this.appConfig.isDev() ? '?dev=true' : '');
    } else {
      this.dangerousURL =
        this.appConfig.getRentalWidgetURL() +
        '/rentals/reserve/' +
        this.partnerIdentifier +
        (this.appConfig.isDev() ? '?dev=true' : '');
    }

    if(this.deliveriesEnabled && this.showNonDeliveriesWidget){
      this.dangerousURL += this.dangerousURL.indexOf("?") > -1 ? "&deliveries_disabled=true" : "?deliveries_disabled=true";
    }

    if(this.selectedProductCategories && this.selectedProductCategories.length > 0){
      this.dangerousURL += (this.dangerousURL.indexOf("?") > -1 ? "&categoryIDs=" : "?categoryIDs=") + this.selectedProductCategories.join(",");
    }
    if(this.selectedProductGroups && this.selectedProductGroups.length > 0){
      this.dangerousURL += (this.dangerousURL.indexOf("?") > -1 ? "&productIdentifiers=" : "?productIdentifiers=") + this.selectedProductGroups.join(",");
    }

    this.iFrameSizer = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.appConfig.getRentalWidgetURL() + '/assets/js/iframeSizer.min.js',
    );
    this.iFrameLink = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.dangerousURL,
    );
    this.iFrameCreated = true;
  }

  showDeliveryWidgetChanged(){
    this.createLink();
  }

  showCategoryWidgetChanged(event){
    this.createLink();
  }

  copyLink() {
    let anyNavigator: any;
    anyNavigator = window.navigator;
    anyNavigator.clipboard.writeText(this.dangerousURL).then(() => {
      this.messageService.add({
        life: 5000,
        closable: false,
        detail: this.translate.instant(
          'bikeshop.shop_ride_configuration.link_copied',
        ),
        key: 'link-copied',
      });
    });
  }

  copyiFrame() {
    var iframe = `<div style="width: 100%;">
    <style>
      iframe {
          width: 1px;
          min-width: 100%;
          border-width: 0px;
          height: 1500px;
      }
      </style>
        <script type="text/javascript" src="${this.appConfig.getRentalWidgetURL() + '/assets/js/iframeSizer.min.js'}"></script>
        <iframe id="rentals-iframe" src="${this.dangerousURL}"></iframe>
        <script>
            iFrameResize({ log: false}, '#rentals-iframe' );
        </script>
    </div>`;

    let anyNavigator: any;
    anyNavigator = window.navigator;
    anyNavigator.clipboard.writeText(iframe).then(() => {
      this.messageService.add({
        life: 5000,
        closable: false,
        detail: this.translate.instant(
          'bikeshop.shop_ride_configuration.iframe_copied',
        ),
        key: 'link-copied',
      });
    });
  }
}
